import { motion } from "framer-motion";
import { ShieldAlert, MapPin, FileHeart, PhoneCall } from "lucide-react";
import { siteContent } from "@/content/site";

const BULLET_ICONS = {
  shield: ShieldAlert,
  map: MapPin,
  file: FileHeart,
  phone: PhoneCall,
};

const { sos } = siteContent;

export default function SOS() {
  return (
    <section
      id="sos"
      data-testid="sos-section"
      className="relative bg-[#1F4E5F] text-[#F4FAF8] overflow-hidden"
    >
      <div className="absolute inset-0 grain pointer-events-none" />
      <div className="absolute -top-32 -right-32 w-[500px] h-[500px] rounded-full bg-[#E8A33D]/25 blur-3xl" />
      <div className="absolute -bottom-32 -left-32 w-[500px] h-[500px] rounded-full bg-[#5BAE71]/15 blur-3xl" />

      <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-20 lg:py-28 grid lg:grid-cols-2 gap-12 items-center">
        <motion.div
          initial={{ opacity: 0, x: -20 }}
          whileInView={{ opacity: 1, x: 0 }}
          viewport={{ once: true, margin: "-80px" }}
          transition={{ duration: 0.7 }}
        >
          <span className="text-xs font-bold uppercase tracking-[0.2em] text-[#E8A33D]">
            {sos.eyebrow}
          </span>
          <h2 className="font-display mt-3 text-3xl sm:text-4xl lg:text-5xl font-bold leading-tight">
            {sos.headingLead}
            <br />
            <em className="italic font-medium text-[#E8A33D]">{sos.headingItalic}</em>
          </h2>
          <p className="mt-5 text-[#F4FAF8]/75 text-lg leading-relaxed">{sos.body}</p>
          <ul className="mt-7 space-y-3">
            {sos.bullets.map((p, i) => {
              const Icon = BULLET_ICONS[p.iconKey] || ShieldAlert;
              return (
                <li key={i} className="flex items-center gap-3">
                  <div className="w-9 h-9 rounded-xl bg-white/10 border border-white/15 flex items-center justify-center shrink-0">
                    <Icon className="w-4 h-4 text-[#E8A33D]" />
                  </div>
                  <span className="text-[#F4FAF8]/90 text-[15px]">{p.t}</span>
                </li>
              );
            })}
          </ul>
        </motion.div>

        <motion.div
          initial={{ opacity: 0, scale: 0.9 }}
          whileInView={{ opacity: 1, scale: 1 }}
          viewport={{ once: true, margin: "-80px" }}
          transition={{ duration: 0.8 }}
          className="flex flex-col items-center justify-center"
        >
          <div className="relative">
            <div className="absolute inset-0 rounded-full bg-[#E55B5B]/30 blur-3xl" />
            <div className="relative w-60 h-60 lg:w-72 lg:h-72 rounded-full bg-gradient-to-br from-[#E55B5B] to-[#C84444] flex flex-col items-center justify-center sos-pulse shadow-[0_0_120px_-10px_rgba(229,91,91,0.6)]">
              <span className="font-display text-5xl lg:text-6xl font-bold tracking-wider">
                SOS
              </span>
              <span className="text-xs font-semibold uppercase tracking-[0.2em] mt-2 opacity-90">
                {sos.holdLabel}
              </span>
            </div>
          </div>
          <p className="text-white/40 text-sm mt-6">{sos.footerLine}</p>
        </motion.div>
      </div>
    </section>
  );
}
